/** Which admin tabs each role / staff department may access */

const ADMIN_ONLY_TABS = new Set(['employees', 'settings']);

const OPS_TABS = new Set([
  'dashboard',
  'collections',
  'boxStickers',
  'consolidateHbl',
  'cbmCalculator',
  'docInvoices',
  'docReceipts',
  'docHbl',
  'shipments',
  'packageScan',
  'shippingAgents',
  'customers',
  'boxItems',
  'emptyBoxes',
  'boxCollection',
  'enquiries',
  'reviews',
]);

const FINANCE_TABS = new Set([
  'dashboard',
  'finance',
  'reports',
  'docInvoices',
  'docReceipts',
  'enquiries',
]);

export function canAccessAdminTab(role, staffDepartment, tabId) {
  if (role === 'admin') return true;
  if (role !== 'staff') return false;
  if (ADMIN_ONLY_TABS.has(tabId)) return false;
  const dept = staffDepartment || 'full';
  if (dept === 'full') return true;
  if (dept === 'ops') return OPS_TABS.has(tabId);
  if (dept === 'finance') return FINANCE_TABS.has(tabId);
  return false;
}

export function filterNavSections(sections, role, staffDepartment) {
  return sections
    .map((section) => ({
      ...section,
      items: section.items.filter((tab) => canAccessAdminTab(role, staffDepartment, tab.id)),
    }))
    .filter((section) => section.items.length > 0);
}

export function defaultTabForRole(role, staffDepartment) {
  if (role === 'admin') return 'dashboard';
  const dept = staffDepartment || 'full';
  if (dept === 'finance') return 'finance';
  return 'dashboard';
}
